import { withMetadata } from '../metadata'
import { getCountries as _getCountries } from '../../core/index'

export function getCountries() {
	return withMetadata(_getCountries, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/getCountries.js
// module id = 633
// module chunks = 0